import axiosInstance from '../../axiosInstance';
import type {
  GetUserTicketsParams,
  TicketResponse,
  TicketsListResponse,
  UserTicketsEventsResponse,
} from './types';

export const ticketsService = {
  /**
   * List user's tickets (paginated)
   * GET /user/tickets
   */
  listTickets: async (params?: GetUserTicketsParams): Promise<TicketsListResponse> => {
    const response = await axiosInstance.get<TicketsListResponse>('/user/tickets', {
      params: {
        page: params?.page ?? 1,
        limit: params?.limit ?? 20,
        code: params?.code,
        orderId: params?.orderId,
        eventId: params?.eventId,
        scheduleId: params?.scheduleId,
        status: params?.status,
        seatZone: params?.seatZone,
        seatRow: params?.seatRow,
        seatColumn: params?.seatColumn,
        issuedFrom: params?.issuedFrom,
        issuedTo: params?.issuedTo,
      },
    });
    return response.data;
  },

  /**
   * List distinct events the user has tickets to, with counts by status
   * GET /user/tickets/events
   */
  listUserTicketEvents: async (includeRevoked?: boolean): Promise<UserTicketsEventsResponse> => {
    const response = await axiosInstance.get<UserTicketsEventsResponse>('/user/tickets/events', {
      params: {
        includeRevoked: includeRevoked ?? false,
      },
    });
    return response.data;
  },

  /**
   * Get a specific ticket
   * GET /user/tickets/{ticketId}
   */
  getTicketById: async (ticketId: string): Promise<TicketResponse> => {
    const response = await axiosInstance.get<TicketResponse>(`/user/tickets/${ticketId}`);
    return response.data;
  },

  /**
   * Get a ticket as JPEG image (blob)
   * GET /user/tickets/{ticketId}/image
   */
  getTicketImage: async (ticketId: string): Promise<Blob> => {
    const response = await axiosInstance.get(`/user/tickets/${ticketId}/image`, {
      responseType: 'blob',
      headers: { Accept: 'image/jpeg' },
    });
    return response.data as Blob;
  },

  /**
   * Get a ticket QR code as PNG image (blob)
   * GET /user/tickets/{ticketId}/qrcode
   */
  getTicketQrCode: async (ticketId: string): Promise<Blob> => {
    const response = await axiosInstance.get(`/user/tickets/${ticketId}/qrcode`, {
      responseType: 'blob',
      headers: { Accept: 'image/png' },
    });
    return response.data as Blob;
  },
};

export default ticketsService;
